export const countriesBase = [
    'United States',
    'Canada',
    'United Kingdom',
    'Germany',
    'France',
    'Japan',
    'Australia',
    'India',
    'Brazil',
    'China',
    'Italy',
    'Spain',
    'South Korea',
    'Mexico',
    'Russia',
    'South Africa',
    'Nigeria',
    'Saudi Arabia',
    'Argentina',
    'Sweden',
];
